import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportViewModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      fatigues: [],
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_report_fatigues.id !== 'undefined') {
        this.setState({
          fatigues: newProps.data_report_fatigues.staff_rfms_report_fatigues,
          data: newProps.data_report_fatigues,
          staff_name: newProps.data_report_fatigues.staff.name,
        });
      }
      if(newProps.simulation == 1) {
        this.setState({
          fatigues: newProps.data_report_fatigues.staff_rfms_report_fatigues,
          data: newProps.data_report_fatigues,
          staff_name: newProps.data_report_fatigues.staff_name,
        });

      }
    }
  }


  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloDadosDoRelatorioDeFadiga} - {self.state.data.date_str} - {self.state.staff_name}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <p>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.paragrafoQuantidadeDePontosAtual}: {self.state.data.actual_points_str}</p>
            <p>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.paragrafoQuantidadeDePontosReportados}: {self.state.data.report_points_str}</p>
            <hr/>
            <table className="table table-bordered table-stripped table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaDadosDoRelatorioDeFadiga.Parametro}</th>
                  <th className="text-center">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaDadosDoRelatorioDeFadiga.Dados}</th>
                  <th className="text-center">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaDadosDoRelatorioDeFadiga.Pontos}</th>
                </tr>
              </thead>
              <tbody id="suppliers-certifications">
                {Object.keys(self.state.fatigues).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.fatigues[k].name}</td>
                      <td className="text-center">
                        {
                          self.state.fatigues[k].type === "options"
                          ?
                          self.state.fatigues[k].fatigue_option_name
                          :
                          self.state.fatigues[k].type === "quantity"
                          ?
                          self.state.fatigues[k].quantity
                          :
                          self.state.fatigues[k].type === "text"
                          ?
                          self.state.fatigues[k].text
                          :
                          self.state.fatigues[k].hours_str
                        }
                      </td>
                      <td className="text-center">{self.state.fatigues[k].total_points}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default StaffRfmsReportViewModal;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportViewModal.js